import { render, staticRenderFns } from "./show-errors-modal.vue?vue&type=template&id=2ef4b91a&scoped=true"
import script from "./show-errors-modal.vue?vue&type=script&lang=js"
export * from "./show-errors-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef4b91a",
  null
  
)

export default component.exports